import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository, TransactionManager, getManager } from "typeorm";
import { AdjustmentNotesEntity } from "./entity/adjustment-note.entity";
import {  CommonResponse } from "@gtpl/shared-models/masters";
import appSettings from "apps/services/config";
import {AdjustmentNoteItemInfo, AdjustmentNoteReq, AdjustmentNoteViewModel} from '@gtpl/shared-models/finance'
import { AdjustmentNoteCategoryEnum, AdjustmentNoteStatusEnum } from "@gtpl/shared-models/common-models";
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { AdjustmentNoteRepository } from "./repository/adjustment-note-repo";
import { AdjusmentNoteRequest,AdjutsmentNoteCategoryReq } from "@gtpl/shared-models/finance";
import { LogsDto } from "libs/shared-models/user-logs/src/lib/Logs/logs.dto";
import { LogsService } from "@gtpl/shared-services/user-logs";

Injectable()
export class AdjustmentNotesService {
    constructor(
        @InjectRepository(AdjustmentNotesEntity)
        private enquiryLogRepo: Repository<AdjustmentNotesEntity> ,
        private logService:LogsService,
        private adjustmentNoteRepo : AdjustmentNoteRepository
    ){ }
    async getAllPrintInfo(req:AdjusmentNoteRequest):Promise<CommonResponse>{
        try{
            
            const manager = getManager()
            let query = `SELECT a.category,a.debit_note_no as debitNo,a.credit_note_no as creditNo,a.invoice_no as invoiceNo,a.price,a.quantity,a.tax_amount,i.item_name AS item,a.created_at as debitDate,a.created_at as creditDate,i.hsn_code,a.tax_percentage,so.po_number as soNum,a.invoice_no as invoiceNo,p.po_number as poNumber,
            a.total_amount,a.status,v.vendor_name,v.contact_number as vendorContact,v.email_id as vendorEmail,v.apartment as vendorApartment,v.street as vendorStreet,v.city as vendorCity,p.plant_address as plantId FROM adjustment_notes a
            LEFT JOIN ${appSettings.masters_db}.vendors v ON v.vendor_id = a.vendor_id
            LEFT JOIN ${appSettings.masters_db}.items i ON i.item_id = a.item_id
            LEFT JOIN ${appSettings.procure_db}.purchase_order p ON p.purchase_order_id = a.po_id
            LEFT JOIN ${appSettings.procure_db}.grn_items gi ON gi.grn_item_id = a.grn_item_id
            LEFT JOIN ${appSettings.sales_db}.so_invoice_details so ON so.inv_details_id = gi.sale_order_id
            where 1=1 `
            if(req.tab === AdjustmentNoteCategoryEnum.DEBIT){
                query +=`and a.debit_note_no = '${req.debitNote}'`
            }
            if(req.tab === AdjustmentNoteCategoryEnum.CREDIT){
                query +=`and a.credit_note_no = '${req.debitNote}'`
            }
            const result = await manager.query(query)
            if(result.length > 0){
                return new CommonResponse(true, 1,'Data retrieved successfully', result)
            }else{
                return new CommonResponse(false, 0,'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async createAdjustmentNote(req:AdjustmentNoteReq):Promise<CommonResponse>{
        const transactionManager = new GenericTransactionManager()
        try{
            await transactionManager.startTransaction()
            let saveFlag = new Set<Boolean>()
            let noteCount
            const getNoteCount = await transactionManager.getCustomRepository(AdjustmentNoteRepository).getNoteCount(req.category)
            if(getNoteCount.id == null){
                noteCount = 0
            }else{
                noteCount = (getNoteCount.id.split(',')).length
            }
            for(const rec of req.adjustmnetNoteItemsInfo){
                const entityObj = new AdjustmentNotesEntity()
                entityObj.category = req.category
                entityObj.vendorId = rec.vendorId
                entityObj.invoiceNumber = rec.invoiceNumber
                entityObj.poId = rec.poId
                entityObj.itemId = rec.itemId
                entityObj.price = rec.price
                entityObj.quantity = rec.quantity
                entityObj.taxAmount = rec.taxAmount
                entityObj.totalAmount = rec.totalAmount
                entityObj.grnItemId = rec.grnItemId
                entityObj.grnId = rec.grnId
                entityObj.taxPercentage = rec.taxPercent
                entityObj.status = AdjustmentNoteStatusEnum.OPEN
                if(req.category == AdjustmentNoteCategoryEnum.DEBIT){
                    entityObj.debitNoteNumber = `DN/${rec.vendorCode}/${(Number(noteCount)+1).toString().padStart(3, '0')}`
                }else {
                    entityObj.creditNoteNumber = `CN/${rec.vendorCode}/${(Number(noteCount)+1).toString().padStart(3, '0')}`
                }
                const save = await transactionManager.getRepository(AdjustmentNotesEntity).save(entityObj)
                if(!save){
                    saveFlag.add(false)
                    await transactionManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong in adjustment note save')
                }else{
                    saveFlag.add(true)
                }
            }
            if(!(saveFlag.has(false))){
                await transactionManager.completeTransaction()
                return new CommonResponse(true,1,'Saved successfully')
            }else{
                await transactionManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in adjustment note save')
            }
        }catch(err){
            await transactionManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong in adjustment note save',err)
        }
    }

    async getAdjustmentNoteInfo(req:AdjutsmentNoteCategoryReq):Promise<CommonResponse>{
        try{
            const info = await this.adjustmentNoteRepo.getAdjustmentNoteInfo(req)
            const noteMap = new Map<string,AdjustmentNoteViewModel>()
            if(info.length > 0){
                if(req.category == AdjustmentNoteCategoryEnum.DEBIT){
                    for(const rec of info){
                        if(!noteMap.has(rec.debit_note_no)){
                            noteMap.set(rec.debit_note_no,new AdjustmentNoteViewModel(rec.adjustment_notes_id,rec.invoice_no,rec.po_number,rec.po_id,rec.vendor_id,rec.vendor_code,rec.vendor_name,rec.category,rec.debit_note_no,rec.credit_note_no,[]))
                        }
                        noteMap.get(rec.debit_note_no).itemsInfo.push(new AdjustmentNoteItemInfo(rec.saleordernumber,rec.sale_order_id,rec.item_id,rec.item_name,rec.price,rec.quantity,rec.tax_amount,rec.total_amount,rec.tax_percentage,rec.grn_item_id,rec.grn_id,rec.grn_no))
                    }
                    
                }else{
                    for(const rec of info){
                        if(!noteMap.has(rec.credit_note_no)){
                            noteMap.set(rec.credit_note_no,new AdjustmentNoteViewModel(rec.adjustment_notes_id,rec.invoice_no,rec.po_number,rec.po_id,rec.vendor_id,rec.vendor_code,rec.vendor_name,rec.category,rec.debit_note_no,rec.credit_note_no,[]))
                        }
                        noteMap.get(rec.credit_note_no).itemsInfo.push(new AdjustmentNoteItemInfo(rec.saleordernumber,rec.sale_order_id,rec.item_id,rec.item_name,rec.price,rec.quantity,rec.tax_amount,rec.total_amount,rec.tax_percentage,rec.grn_item_id,rec.grn_id,rec.grn_no))
                    }
                }
                const noteModel : AdjustmentNoteViewModel[] = []
                noteMap.forEach((e => noteModel.push(e)))
                const newLogDto = new LogsDto(1,'Debit Credit Note', 'adjustment_notes', 0, true, 'Data retrieved','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
               return new CommonResponse(true,1,'Data retrieved',noteModel)
            }else{
                return new CommonResponse(false,0,'No Data found')
    
            }
        }catch(err){
            throw err
        }
    }

    async getNoteNumberDropDown(req:AdjutsmentNoteCategoryReq):Promise<CommonResponse>{
        try{
            // const data = await this.adjustmentNoteRepo.find({select:['debitNoteNumber','creditNoteNumber'],where:{category:req.category}})
            const data = await this.adjustmentNoteRepo.getNoteNumberDropDown(req)
            if(data.length > 0){
                return new CommonResponse(true,1,'Data retrieved',data)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getInvoiceNumberDropDown(req:AdjutsmentNoteCategoryReq):Promise<CommonResponse>{
        try{
            // const data = await this.adjustmentNoteRepo.find({select:['invoiceNumber'],where:{category:req.category}})
            const data = await this.adjustmentNoteRepo.getInvoiceNumberDropDown(req)
            if(data.length > 0){
                return new CommonResponse(true,1,'Data retrieved',data)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getVendorDropDown(req:AdjutsmentNoteCategoryReq):Promise<CommonResponse>{
        try{
            const data = await this.adjustmentNoteRepo.getVendorDropDown(req)
            if(data.length > 0){
                return new CommonResponse(true,1,'Data retrieved',data)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }
}